<script>
import SessionQuotesGrouped from "@/components/Session/SessionQuotesGrouped.vue";
// import BlockQuotes from "@/components/Block/BlockQuotes.vue";

export default {
    name: "SessionSummary",
    components: {/*BlockQuotes, */SessionQuotesGrouped},
    props: {
        session: {
            type: Object,
        },
        idProject: {
            type: String,
        },
        idSessionEps: {
            type: Number,
        },
    },
    computed: {
        summary() {
            return this.session?.summary || {};
        },
    },
}
</script>

<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-textarea
                    label="Саммари"
                    v-model="summary.summary"
                    :auto-grow="true"
                    :rows="1"
                    readonly
                ></v-textarea>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <session-quotes-grouped
                    :id-project="idProject"
                    :id-session="session.id"
                    :id-session-eps="idSessionEps"
                ></session-quotes-grouped>
            </v-col>
        </v-row>
<!--        <v-row>
            <v-col>
                <block-quotes :id-project="idProject" :id-session-eps="idSessionEps"></block-quotes>
            </v-col>
        </v-row>-->
    </v-container>
</template>

<style scoped lang="scss">

</style>